import { useQuery } from '@tanstack/react-query'
import { fetchClientJournal } from '@/lib/api/universe'
import { journalWindow } from '@/lib/compute/client-journal'

/** The last six weeks of a client's journal, newest week first. */
export function useClientJournal(clientId: string | undefined) {
  return useQuery({
    queryKey: ['client-journal', clientId],
    queryFn: () => {
      const { from, to } = journalWindow(new Date())
      return fetchClientJournal(clientId!, { from, to })
    },
    enabled: !!clientId,
    // The journal is written once a night, so 30 min is never stale in practice.
    staleTime: 30 * 60_000,
  })
}
